// src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../context/UserContext';

const ProtectedRoute = () => {
  const { user } = useUser();

  // Se não houver usuário logado, redireciona para a página inicial (login)
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Se houver um usuário logado, renderiza o componente da rota solicitada
  return <Outlet />;
};

export default ProtectedRoute;